export enum ActionTypes {
  GetExpertServicesOngoing = 'getExpertServicesOngoing',
  GetExpertServicesOngoingRequest = 'getExpertServicesOngoing.request',
  GetExpertServicesOngoingSuccess = 'getExpertServicesOngoing.success',
  GetExpertServicesOngoingFailure = 'getExpertServicesOngoing.failure',
}
